import type { ReactNode } from "react";
import { createContext, useContext } from "react";

import type { ModalDialogProps } from "./ModalDialog.tsx";

/**
 * Usage:
 * Open a custom modal by specifying ModalDialogProps with optional Id:
 * -- openModalDialog(modalProps, "customModalId");
 *
 */
type ModalDialogContextValue = {
  openModalDialog: (modalProps: ModalDialogProps, id?: string) => void;
  closeModalDialog: (id?: string) => void;
  openErrorDialog: (message: ReactNode, title?: ReactNode) => void;
  setDialogClosable: (id: string, closable: boolean) => void;
};

export const ModalDialogContext = createContext<ModalDialogContextValue | undefined>(undefined);

export const useModalDialog = () => {
  const modalDialogContext = useContext(ModalDialogContext);

  if (!modalDialogContext) {
    throw new Error(`Missing ModalDialogContextProvider in component tree.`);
  }

  return modalDialogContext;
};
